import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useEffect, useState } from "react";

export default function Highchart({
  title,
  items = [],
  onClickParams = [],
  onTitleClick = null,
  id = null,
}) {
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(items);
  }, [items]);

  useEffect(() => {
    setTimeout(() => {
      let title = document.getElementById(id);
      console.log(id, title);
      if (title) {
        title.addEventListener("click", onTitleClick);
      }
    }, 500);
  }, [items]);

  const options = {
    chart: {
      type: "column",
    },
    title: {
      useHTML: true,
      text: onTitleClick
        ? `<a id="${id}" href='javascript.void()' >${title}</a>`
        : title,
      style: onTitleClick
        ? {
            cursor: "pointer", // Changes cursor to pointer on hover
            textDecoration: "underline",
          }
        : {},
    },
    // subtitle: {
    //   text: "work hours from 09:00 to 19:00 by Kyiv",
    // },
    xAxis: {
      type: "category",
      labels: {
        autoRotation: [-45, -90],
        style: {
          fontSize: "13px",
          fontFamily: "Verdana, sans-serif",
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Work hours",
      },
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      pointFormat: "<b>{point.y:.1f} hours</b>",
    },
    series: [
      {
        name: "Work time",
        colors: ["#1f88b7"],
        colorByPoint: true,
        groupPadding: 0,
        data: data,
        dataLabels: {
          enabled: true,
          rotation: -90,
          color: "#FFFFFF",
          inside: true,
          verticalAlign: "top",
          format: "{point.y:.1f}", // one decimal
          y: 10, // 10 pixels down from the top
          style: {
            fontSize: "13px",
            fontFamily: "Verdana, sans-serif",
          },
        },
        point: {
          events: {
            click: function () {
              let params = onClickParams[this.category];
              const url = `/user?id=${params?.assignee_id}&dateFrom=${params?.date}&dateTo=${params?.date}`;
              if (url) {
                window.open(url, "_blank");
              } else {
                console.error(`No URL defined for ${this.category}`);
              }
            },
          },
        },
      },
    ],
  };

  return (
    <>
      {data && (
        <div style={{ paddingTop: "40px" }}>
          <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
      )}
    </>
  );
}
